import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useEffect, useRef, useState } from 'react';

import { LogsColumns } from 'components/common/enhanced/common-headers/logs';
import { useParams } from 'react-router-dom';
import { logService } from 'services/api/LogService';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import VersionDialog from './VersionDialog';
import { MODELS_MAPS } from 'components/common/HistoryList/versions/Versions';

export const DeletedLogsPerObject = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.versions.deleted.view';
  const datagridRefresh = useRef(null);

  const { model_name, object_id } = useParams();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState<number>(null);

  const handleOpenDialog = (id: number) => {
    setSelectedVersion(id);
    setDialogOpen(true);
  };

  const columns: GridColDef[] = LogsColumns(handleOpenDialog);

  return (
    <TenantPage
      title={`${t(`${translationPrefix}.title`)}`}
      subtitle={`${MODELS_MAPS[model_name].label} id: ${object_id}`}>
      <div className="mt-6">
        <EnhancedDataGrid
          columns={columns}
          service={logService}
          refresh={datagridRefresh}
          disableFilter
          outerParams={{ object_id: object_id, model_name: model_name }}
        />
      </div>
      {selectedVersion && (
        <VersionDialog
          open={dialogOpen}
          onClose={() => {
            setSelectedVersion(null);
            setDialogOpen(false);
          }}
          versionId={selectedVersion}
        />
      )}
    </TenantPage>
  );
};

export default DeletedLogsPerObject;
